/**
 * The assistant's kits, as the gateway serves them for the editor: each one
 * switches its tools and its prompt section on or off for this page's life.
 */

import React, { useEffect, useState } from 'react';
import { agentService } from './AgentService';
import { getKitManifest, isKitOn, onKitsChange, setKitOn } from './kits';
import { getPluginByToolName } from '../plugins/registry';
import * as styles from './chat-styles';

export const KitSettings: React.FC<{ labelStyle: React.CSSProperties }> = ({ labelStyle }) => {
    const [, setTick] = useState(0);
    useEffect(() => onKitsChange(() => setTick(n => n + 1)), []);
    useEffect(() => {
        // Once loaded, the kits are each turn's to read again; the settings never swap them under a running one.
        if (!getKitManifest()) agentService.ensureKits().catch((err: unknown) => console.warn('[AI] kits not loaded:', err));
    }, []);
    const manifest = getKitManifest();
    if (!manifest) return null;
    return (
        <div style={{ borderTop: `1px solid ${styles.colors.border}`, paddingTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label style={labelStyle}>Kits</label>
            {manifest.kits.map(kit => (
                <label key={kit.name} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: styles.colors.text, cursor: 'pointer' }}>
                    <input type="checkbox" checked={isKitOn(kit.name)} onChange={e => setKitOn(kit.name, e.target.checked)} />
                    {kit.name.replace(/^editor\./, '')}
                    <span style={{ color: styles.colors.textMuted }}>{kit.tools.filter(tool => getPluginByToolName(tool)).length} tools here</span>
                </label>
            ))}
        </div>
    );
};
